// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import InputField from './form-fields/input-field';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import WarrantyDatePicker from '../../../shared/components/warranty-date-picker';
import {buildMoment} from '../../../shared/services/build-moment';

function handleDateChange(date) {

    if (date) {

        this.onItemChange('postalDeliveryDate', date.utc().startOf('day').valueOf());

    }

}

const NoResponseDetails = props =>
    <div className='no-response-details'>
        <InputField
            label='POSTAL_TRACKING_NUMBER'
            onItemChange={props.onItemChange}
            propertyToUpdate='postalTrackingNumber'
        />
        <div className='labeled-string date-picker-wrapper'>
            <span className='data-label asterisk-after'>
                <FormattedMessage id='POSTAGE_DELIVERY_DATE'/>
            </span>
            <WarrantyDatePicker
                onChange={props::handleDateChange}
                selected={buildMoment(props.pipCode.postalDeliveryDate)}
            />
        </div>
    </div>;

NoResponseDetails.displayName = 'NoResponseDetails';
NoResponseDetails.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    pipCode: PropTypes.instanceOf(PipCode).isRequired
};

export default NoResponseDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/no-response-details.js